export default __webpack_public_path__ + "static/media/carou2_alt.20b9639e.jpg";